import * as React from 'react'

import { Modal as SGModal } from '@espoon-voltti/react-components/components/modal'

import { ModalConfigCtx, IdCtx } from './context'
import { ModalUserConfig } from './types'
import { Modals, ModalsApi } from './use-modals'

export const Modal: React.FC<ModalUserConfig> = (props) => {
  const ctx = React.useContext(ModalConfigCtx)
  const id = React.useContext(IdCtx)
  const modals = Modals.use()

  if (!ctx) {
    throw new Error('ModalContainer must be inside ModalDefaultProvider')
  }

  if (!id) {
    throw new Error('ModalContainer must be inside IdCtx.Provider')
  }

  const modalProps = {
    ...ctx,
    ...props
  }

  const onConfirm = (modals: ModalsApi) => () => {
    if (modalProps.onConfirm() === 'CLOSE') {
      modals.remove(id)
    }
  }

  const onCancel = (modals: ModalsApi) => {
    const action = modalProps.onCancel
    if (!action) {
      return undefined
    }
    return () => {
      if (action() === 'CLOSE') {
        modals.remove(id)
      }
    }
  }

  return (
    <SGModal
      {...modalProps}
      onConfirm={onConfirm(modals)}
      onCancel={onCancel(modals)}
    />
  )
}
